export const issueListEuht = [
  {
    titleKey: 'poorResults.euht.title.sanitizerSupply',
    detailsKey: 'poorResults.euht.details.sanitizerSupply',
    keyValue: 1,
    answered: false,
    status: '',
    expanded: false,
    images: [],
    video: ''
  },
  {
    titleKey: 'poorResults.euht.title.waterTempIssue',
    detailsKey: 'poorResults.euht.details.waterTempIssue',
    keyValue: 2,
    answered: false,
    status: '',
    expanded: false,
    images: [],
    video: ''
  },
  {
    titleKey:'poorResults.euht.title.waterOn',
    detailsKey: '',
     keyValue: 3,
    answered: false,
    status: '',
    expanded: false,
    images: [],
    video: ''
  },
  {
    titleKey: 'poorResults.euht.title.endCapIssue',
    detailsKey: 'poorResults.euht.details.endCapIssue',
     keyValue: 4,
    answered: false,
    status: '',
    expanded: false,
    images: [
      'assets/images/troubleshooting/eult/eult-spray-arm-end-cap-1.png',
      'assets/images/troubleshooting/eult/eult-spray-arm-end-cap-2.png'
    ],
    video: '',
    isImagePopup: true
  },
  {
    titleKey: 'poorResults.euht.title.armSpinIssue',
    detailsKey: 'poorResults.euht.details.armSpinIssue',
    keyValue: 5,
    answered: false,
    status: '',
    expanded: false,
    images: ['assets/images/troubleshooting/eult/eult-arm-spin.gif'],
    video: '',
    isImagePopup: false
  },
  {
    titleKey: 'poorResults.euht.title.noDebris',
    detailsKey: 'poorResults.euht.details.noDebris',
     keyValue: 6,
    answered: false,
    status: '',
    expanded: false,
    images: [
      'assets/images/poorresults/lime-scale.png',
      'assets/images/poorresults/lime-scale-dirt.png'
    ],
    video: '',
    isImagePopup: false
  },
  {
    titleKey: 'poorResults.euht.title.primeChemist',
    detailsKey: '',
    keyValue: 7,
    answered: false,
    status: '',
    expanded: false,
    images: [
      'assets/images/troubleshooting/eult/eult-chemistry.jpg',
      'assets/images/troubleshooting/eult/prime-chemist.gif'
    ],
    video: '',
    isImagePopup: false
  },
  {
    titleKey: 'poorResults.euht.title.noLimescale',
    detailsKey: 'poorResults.euht.details.noLimescale',
     keyValue: 8,
    answered: false,
    status: '',
    expanded: false,
    images: [
      'assets/images/poorresults/lime-scale.png',
      'assets/images/poorresults/lime-scale-dirt.png'
    ],
    video: '',
    isImagePopup: true
  },
  {
    titleKey: 'poorResults.euht.title.softener',
    detailsKey: 'poorResults.euht.details.softener',
    keyValue: 9,
    answered: false,
    status: '',
    expanded: false,
    images: [],
    video: ''
  }
];
